import * as userRequest from "@/utils/userRequest";

export default async function getDeviceInfo(
    data: {
        deviceId: string;
    },
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.post(
            "auth/device-info",
            {
                ...data,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (res) {
            onSuccess && onSuccess(res.data);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ getDeviceInfo ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
